import type { DataTableBodyStore } from "@src/components/ui-kit/DataTable/Body/store";
import type { Updater, VisibilityState } from "@tanstack/react-table";
import { useMemo } from "react";

type UseTableBodySettingsArgs = {
  tanstackBodyStore: DataTableBodyStore;
  hasCustomColumnOrder: boolean;
  dataColumnIds: string[];
  hideableDataColumnIds: string[];
};
export function useTableBodySettings({
  tanstackBodyStore,
  hasCustomColumnOrder,
  dataColumnIds,
  hideableDataColumnIds,
}: UseTableBodySettingsArgs) {
  const hasCustomColumnSizing =
    Object.keys(tanstackBodyStore.columnSizing).length > 0;

  const hasCustomColumnVisibility =
    tanstackBodyStore.hiddenColumnIds.length > 0;

  const hasCustomColumnPinning = tanstackBodyStore.pinnedColumnIds.length > 0;

  const isResetColumnPreferencesDisabled =
    !hasCustomColumnSizing &&
    !hasCustomColumnOrder &&
    !hasCustomColumnVisibility &&
    !hasCustomColumnPinning;

  const onResetColumnPreferences = () => {
    tanstackBodyStore.resetColumnPreferences(dataColumnIds);
  };

  const columnVisibility = useMemo(
    () =>
      hideableDataColumnIds.reduce<VisibilityState>((acc, id) => {
        acc[id] = !tanstackBodyStore.hiddenColumnIds.includes(id);
        return acc;
      }, {}),
    [hideableDataColumnIds, tanstackBodyStore.hiddenColumnIds],
  );

  const onColumnVisibilityChange = (updater: Updater<VisibilityState>) => {
    tanstackBodyStore.updateColumnVisibility(updater, hideableDataColumnIds);
  };

  return {
    columnVisibility,
    onColumnVisibilityChange,
    onResetColumnPreferences,
    isResetColumnPreferencesDisabled,
  };
}
